/**
 * Las plantillas que PUX provisiona solo, por orden de aparición en el panel.
 *
 * ───────────────────────────────────────────────────────────────────────────────
 * POR QUÉ ESTA LISTA EXISTE Y NO SE DERIVA DEL DOCUMENTO
 * ───────────────────────────────────────────────────────────────────────────────
 * Un número puede tener plantillas que PUX no gestiona: hoy `pux_prueba_4b`,
 * `pux_promo_prueba` y `pux_promo_prueba_2`, creadas a mano. El panel no habla de
 * esas —no las provisiona, no las re-aprovisiona y no puede explicar su estado—, así
 * que listarlas sería prometer un control que no tiene.
 *
 * Lo contrario tampoco vale: leer sólo `appointment_reminder`, que es lo que hacía
 * hasta el 21-sep-2026. Cuando llegó `retomar_conversacion`, el callable la
 * provisionaba y su estado quedaba en Firestore **sin que nadie pudiera verlo**. El
 * panel decía la verdad sobre una plantilla y callaba sobre la otra.
 *
 * ⚠️ LA AUTORIDAD ESTÁ EN `functions/`, NO AQUÍ. Los nombres reales son las
 * constantes `TEMPLATE_NAME` de `integrations/templates/appointmentReminder.js` y
 * `integrations/templates/retomarConversacion.js`. `src/` no puede importar de
 * `functions/`, así que esta lista es una copia — y lo que impide que diverja es
 * `functions/__tests__/panelMuestraTodasLasPlantillas.jest.test.js`, que compara
 * las dos cosas y corre en el gate de pre-commit.
 *
 * El día que se añada una tercera plantilla y no se toque este fichero, ese test se
 * pone rojo. Sin él, la tercera sería invisible en el panel: el mismo fallo otra vez.
 */

export const PLANTILLAS_DE_PUX = [
  'appointment_reminder',
  'retomar_conversacion',
];

/** Los idiomas que se provisionan, en el orden en que se piden a Meta. */
export const IDIOMAS = ['es_MX', 'en_US', 'pt_BR'];

/**
 * ¿Hay que avisar de la categoría que Meta asignó?
 *
 * Sólo cuando NO es UTILITY. Una plantilla puede estar APPROVED y aun así no servir
 * para reabrir una conversación: `esOfrecibleEnElBanner` (en el backend) la deja
 * fuera si Meta la clasificó MARKETING, porque el envío de plantilla desde la bandeja
 * todavía no comprueba consentimiento. Un «Aprobada» en verde sin ese aviso haría
 * creer al operador que puede usarla.
 *
 * `null` no avisa: una plantilla aún sin categoría registrada está normalmente en
 * revisión, y ahí el estado ya lo dice todo.
 */
export function categoriaQueLimita(entry) {
  const cat = entry?.category;
  if (!cat) return null;
  return cat === 'UTILITY' ? null : cat;
}
